import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  DIALOG: `${cleanedFilename(__filename)}-dialog`,
};
